<div class="flex items-center justify-center dialog-header ">
    <div *ngIf="communicationData?.first_name">
        Email to {{communicationData?.first_name}} {{communicationData?.last_name}}
    </div>
    <div *ngIf="!communicationData?.first_name">
        Send Email
    </div>

    <div class="absolute right-2">
        <button (click)="handleCloseNoteDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">

    <div>
        <div class="mb-2 font-medium">Subject of Email</div>
        <input class="w-full" style="box-shadow: none !important;" type="text" pInputText [(ngModel)]="emailSubject" />
    </div>

    <div class="mt-5">
        <p-editor [(ngModel)]="emailBody" class="w-full gray-input" [style]="{ height: '320px' }" />
    </div>

    <!-- Attachments Section -->
    <div class="mt-4 border rounded-lg p-3">
        <div class="flex items-center justify-between mb-2">
            <label class="font-semibold text-sm">Attachments</label>
            <p-fileUpload 
                mode="basic" 
                chooseLabel="Add Attachment" 
                chooseIcon="pi pi-paperclip"
                (onSelect)="onFileSelect($event)" 
                [multiple]="true"
                [auto]="true"
                accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                [maxFileSize]="10485760"
                class="attachment-upload"
                [style]="{'font-size': '0.875rem'}">
            </p-fileUpload>
        </div>
        
        <div *ngIf="attachments.length > 0" class="flex flex-wrap gap-2">
            <div *ngFor="let attachment of attachments; let i = index" 
                 class="relative border rounded-lg p-2 min-w-[120px] max-w-[180px] bg-gray-50"
                 [class.opacity-50]="attachment.uploading"
                 [class.pointer-events-none]="attachment.uploading">
                
                <!-- Loading Overlay -->
                <div *ngIf="attachment.uploading" 
                     class="absolute inset-0 flex items-center justify-center bg-gray-200 bg-opacity-75 rounded-lg z-10">
                    <p-progressSpinner [style]="{width: '25px', height: '25px'}" 
                                       strokeWidth="4">
                    </p-progressSpinner>
                </div>
                
                <!-- Attachment Content -->
                <div class="flex items-center gap-2">
                    <i [class]="'pi ' + getFileIcon(attachment.type) + ' text-xl text-blue-600'"></i>
                    <div class="flex-1 overflow-hidden">
                        <div class="text-xs font-medium truncate">{{attachment.name}}</div>
                        <div class="text-xs text-gray-500 capitalize">{{attachment.type}}</div>
                    </div>
                    <button *ngIf="!attachment.uploading" 
                            type="button"
                            (click)="removeAttachment(i)" 
                            class="text-red-500 hover:text-red-700 text-sm">
                        <i class="pi pi-trash"></i>
                    </button>
                </div>
            </div>
        </div>
        
        <div *ngIf="attachments.length === 0" class="text-xs text-gray-500 text-center py-1">
            No attachments added
        </div>
    </div>

    <div class="flex justify-end  mt-4">
        <p-button label="Send" [loading]="loading" [disabled]="loading" icon="pi pi-send" class="flex justify-end"
            (click)="handleSendEmail()"></p-button>
    </div>
</div>


<p-dialog [modal]="true" [(visible)]="isOpenNotesModal" appendTo="body"
    [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <app-communication-note (closeDialog)="handleCloseAllDialogs()" [communicationData]="communicationData"
        [emailExtraDetails]="emailExtraDetails" [type]="'email'"></app-communication-note>
</p-dialog>